import { array, boolean, number, object, string, z } from "zod";

export const SearchInputsSchema = object({
  Id: string().optional(),
  age: array(number()).optional(),
  height: array(number()).optional(),
  weight: array(number()).optional(),
  country: string().optional(),
  city: string().optional(),
  children: string().optional(),
  eyeColor: string().optional(),
  hairColor: string().optional(),
  appearanceType: string().optional(),
  englishSkill: string().optional(),
  smoking: string().optional(),
  drinking: string().optional(),
  religion: string().optional(),
  zodiacSign: string().optional(),
  topLadies: boolean().optional(),
  birthdaySoon: boolean().optional(),
  newest: boolean().optional(),
  online: boolean().optional(),
  hasVideo: boolean().optional(),
  ladiesWithCam: boolean().optional(),
  hasIntroVideo: boolean().optional(),
}).transform((data) => {
  if (data.Id) {
    return { Id: data.Id };
  } else {
    return data;
  }
});

export type SearchInputsSchema = z.infer<typeof SearchInputsSchema>;
